<template id="toggles">
    <div class="toggles-group" v-if="isMultiple" >
        <button v-bind:key="key" type="button" v-for="(key, val) in values" @click="changeSelectVal(key, key)" :class="['button', { 'button-selected': dash.includes(selected, key), 'button-default': dash.includes(selected, key) }]" v-html="val">{{ val }}</button>
    </div>
    <div class="toggles-group" v-else >
        <button v-bind:key="key" type="button" v-for="(key, val) in values" @click="changeSelectVal(key)" :class="['button', { 'button-selected': selected === key, 'button-default': selected !== key }]" v-html="val">{{ val }}</button>
    </div>
</template>

<script>
export default {
    name: "toggles",
    props: ['values','selected','default', 'multiple'],
    data() {
        return {
            isMultiple: !_.isUndefined(this.multiple),
            dash: window._,
            mutableSelected: this.selected
        }
    },
    ready() {
        this.mutableSelected = this.default;
        this.selected = this.default;
    },
    methods: {
        changeSelectVal: function(val, key) {
            if(this.isMultiple) {

                console.info("this.mutableSelected", this.mutableSelected)
                if(_.isArray(this.mutableSelected) === false) {
                    console.log("Resseting mutableSelected to array", this.mutableSelected)
                    this.mutableSelected = [];
                }

                if(_.includes(this.mutableSelected, val)){
                    this.mutableSelected.splice(this.mutableSelected.indexOf(val), 1)
                } else {
                    this.mutableSelected.push(val)
                }
                this.$emit('update:selected' , this.mutableSelected.sort())
            } else {
                console.log("Updating single value", val)
                this.$emit('update:selected' , val)
            }
        }
    },
    watch: {}
}
</script>

<style lang="scss">
    .toggles-group {
        // border: 1px solid #0074af;
        border: none;
        box-shadow: none;

        button {
            background:  linear-gradient(to bottom, #ffffff 70%,#f4f4f4 100%);
            padding: 10px 20px;
            margin: 2px;
            border-radius: 3px;
            font-weight: 300;

            &:hover {
                border-color: #000;
                cursor: pointer;
            }

            &:active {
                position: relative;
                top: 2px;
            }

            &.button-selected {
                background: linear-gradient(to bottom, #32b643 70%, #129a24 100%);
                border: 1px solid #12541a;
                color: #fff;
                text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.3411764705882353);
                font-weight: bold;
                box-shadow: 0px 1px 0px rgb(70, 212, 88) inset, 0px 0px 10px rgba(50, 182, 67, 0.549);

                &:hover {
                    border-color: #000;
                }
            }
        }
    }
</style>




// WEBPACK FOOTER //
// src/components/Toggles.vue